import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { StoreData } from '../reducers/typings'
import { IDivision } from './typings'
import { getDivisions } from './api'

const divisionAdapter = createEntityAdapter<IDivision>({
  sortComparer: (a, b) => a.name.localeCompare(b.name),
})

export const initialState = divisionAdapter.getInitialState()

export const divisions = createSlice({
  name: 'divisions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDivisions.fulfilled, (state, { payload }) => {
      divisionAdapter.setAll(state, payload)
    })
    builder.addCase(getDivisions.pending, (state) => {
      divisionAdapter.removeAll(state)
    })
  },
})

export default divisions.reducer

export const divisionAdapterSelectors = divisionAdapter.getSelectors<StoreData>(
  (state) => state.divisions,
)

export const { selectAll: selectAllDivisions, selectById: selectDivisionById } =
  divisionAdapterSelectors

export const divisionDisplayName = (s: IDivision) =>
  s.description.trim() == '' ? s.name : `${s.name}- ${s.description}`
